import { IJwtPayload, OAuthConfig } from '../../types';

import OAuthService from './OAuthService';

export default abstract class OAuthTokenService extends OAuthService {
  endpointToken = '/token';

  /*  */
  constructor(oAuthConfig: OAuthConfig) {
    super(oAuthConfig);
  }

  /*  */
  tokenCheckIsExpired(token: IJwtPayload) {
    return token.exp <= Math.floor(Date.now() / 1000);
  }

  /*  */
  abstract tokenParse(_jwt: string): IJwtPayload;

  /*  */
  tokenRefresh(refreshToken: string) {
    return this.formSendAndProcess(this.endpointToken, [
      ['grant_type', 'refresh_token'],
      ['refresh_token', refreshToken]
    ]);
  }
}